export default "__VITE_ASSET__vPAVyMuo__"